export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Contact Us Today',
      description: 'Call us at (915) 206-5814 or fill out our form. Tell us about your situation and your foreclosure timeline. We respond immediately because we know time is critical when you need to avoid foreclosure.',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'Get Your Cash Offer',
      description: 'We\'ll evaluate your property and make you a fair cash offer within 24 hours. No obligation, no pressure. Our offers are based on current El Paso market values and your home\'s condition.',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      number: '03',
      title: 'Accept and Schedule Closing',
      description: 'If you accept our offer, we\'ll work with your lender to schedule a closing date that works for you. We can close in as little as 7 days to help you avoid foreclosure before the sale date.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '04',
      title: 'We Handle Everything',
      description: 'Our team manages all paperwork, coordinates with your lender, handles title work, and takes care of every detail. You don\'t have to worry about anything - we make it easy to avoid foreclosure.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '05',
      title: 'Close and Get Paid',
      description: 'At closing, we pay off your mortgage and any liens, and you receive your cash. Walk away with money in your pocket, your credit protected, and the stress of foreclosure behind you.',
      icon: 'ri-hand-coin-line'
    },
    {
      number: '06',
      title: 'Move Forward',
      description: 'Start your fresh chapter with peace of mind. You\'ve successfully avoided foreclosure, protected your credit score, and can now focus on rebuilding your financial future without the burden of an unwanted property.',
      icon: 'ri-arrow-right-up-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            Our Simple 6-Step Process to Avoid Foreclosure
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We've streamlined the process to help you avoid foreclosure quickly and easily. From first contact to closing, we handle everything so you can focus on your next chapter.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-shadow relative">
              <div className="absolute -top-4 -left-4 w-16 h-16 bg-teal-600 text-white rounded-xl flex items-center justify-center text-2xl font-black shadow-lg">
                {step.number}
              </div>
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6 ml-auto">
                <i className={`${step.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
              <p className="text-base text-gray-700 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="relative rounded-2xl overflow-hidden">
          <img 
            src="https://public.readdy.ai/ai/img_res/3b262e6a201e71cd2457f7dcca45b6d8.jpg" 
            alt="Our process to help you avoid foreclosure" 
            className="w-full h-auto"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 to-gray-900/60 flex items-center">
            <div className="max-w-2xl mx-auto px-8 text-center">
              <h3 className="text-3xl md:text-4xl font-black text-white mb-6">
                Ready to Start the Process?
              </h3>
              <p className="text-lg text-gray-200 mb-8 leading-relaxed">
                Every day counts when you're trying to avoid foreclosure. Contact us now for your free, no-obligation cash offer and take the first step toward financial freedom.
              </p>
              <a 
                href="tel:+1-915-206-5814" 
                className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-10 py-4 rounded-lg text-lg font-bold transition-all shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call (915) 206-5814 Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}